export default __webpack_public_path__ + "static/media/documentolog.f67ae483.png";